(() => {
  if (window.scrollToCollectionResults) return;

  const cssNumber = (name) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;

  // header 被强制隐藏后不占位，只需避开真正吸顶的公告条
  const getStickyOffset = () => cssNumber('--announcement-bar-is-sticky') * cssNumber('--announcement-bar-height');

  const hideHeader = () => {
    document.documentElement.classList.add('header-force-hidden');
    document.dispatchEvent(new CustomEvent('header:hide'));
  };

  // 滚动停稳后才交还 header，否则中途的向上滚动会把它重新显示出来；
  // smooth 滚动启动前有若干帧位置不变，所以必须同时确认已经到达目标位置
  const releaseHeaderWhenSettled = (targetTop) => {
    let lastY = null;
    let stableFrames = 0;
    let frames = 0;

    const check = () => {
      const y = Math.round(window.scrollY);
      const atTarget = Math.abs(y - Math.round(targetTop)) <= 2;
      stableFrames = y === lastY && atTarget ? stableFrames + 1 : 0;
      lastY = y;
      frames += 1;

      if (stableFrames >= 3 || frames > 180) {
        document.documentElement.classList.remove('header-force-hidden');
        return;
      }

      requestAnimationFrame(check);
    };

    requestAnimationFrame(check);
  };

  const scrollToResults = (scope) => {
    const root = scope || document;
    const target =
      root.querySelector('.collection') ||
      root.querySelector('collection-sticky-bar') ||
      root.querySelector('.collection__results') ||
      root.querySelector('.collection-empty');

    if (!target) return false;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const top = Math.min(Math.max(0, target.getBoundingClientRect().top + window.scrollY - getStickyOffset()), maxTop);

    hideHeader();
    window.scrollTo({ top, behavior });
    releaseHeaderWhenSettled(top);

    return true;
  };

  window.scrollToCollectionResults = scrollToResults;

  document.addEventListener('change', (event) => {
    const collection = event.target.closest?.('collection-layout-selector-button')?.closest('.collection');
    if (!collection) return;

    // 等宫格属性生效、重排完成后再取位置
    requestAnimationFrame(() => requestAnimationFrame(() => scrollToResults(collection)));
  });
})();
